import React from "react";
import { Image, Spin, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const MEDIA_PLACEHOLDER = "/img/others/dummy-header.jpg";

const overlayButtonStyle = {
  width: 48,
  height: 48,
  borderRadius: "50%",
  background: "rgba(55, 55, 55, 0.88)",
  border: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  cursor: "pointer",
  padding: 0,
};

const IncomingImagePreview = ({
  message,
  isDownloading = false,
  onDownload,
  compact = false,
  inGrid = false,
  isOverflowCell = false,
  isMobile = false,
  inDrawer = false,
}) => {
  const url = message?.media_url;
  const isDownloaded = !!url;
  const mediaStyle = compact
    ? {
        width: "100%",
        height: (inDrawer && !isMobile && isDownloaded) ? "auto" : "100%",
        minHeight: (inDrawer && !isMobile && isDownloaded) ? undefined : 120,
        objectFit: (inDrawer && !isMobile && isDownloaded) ? "contain" : "cover",
        display: "block",
      }
    : {
        height: "200px",
        objectFit: "cover",
        borderRadius: "8px",
      };

  if (url) {
    return (
      <div
        style={{
          position: "relative",
          display: compact ? "block" : "inline-block",
          width: compact ? "100%" : undefined,
          height: (compact && (isMobile || !inDrawer || !isDownloaded)) ? "100%" : undefined,
        }}
      >
        <Image
          src={url}
          alt="message"
          loading="lazy"
          style={mediaStyle}
          preview={Boolean(url) && !isOverflowCell}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        position: "relative",
        display: compact ? "block" : "inline-block",
        width: compact ? "100%" : undefined,
        height: (compact && (isMobile || !inDrawer || !isDownloaded)) ? "100%" : undefined,
        borderRadius: compact ? 0 : "8px",
        overflow: "hidden",
        background: "#e8e8e8",
      }}
    >
      <img
        src={MEDIA_PLACEHOLDER}
        alt="placeholder"
        style={{
          ...mediaStyle,
          width: compact ? "100%" : "200px",
          opacity: 0.55,
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isDownloading ? (
          <div
            style={{
              ...overlayButtonStyle,
              width: compact ? 40 : 48,
              height: compact ? 40 : 48,
              cursor: "default",
            }}
          >
            <Spin size="small" />
          </div>
        ) : (
          <Tooltip title="Download Image" placement="top">
            <button
              type="button"
              aria-label="Download Image"
              style={{
                ...overlayButtonStyle,
                width: compact ? 40 : 48,
                height: compact ? 40 : 48,
              }}
              onClick={(event) => {
                event.stopPropagation();
                onDownload?.();
              }}
              disabled={!onDownload}
            >
              <DownloadOutlined style={{ fontSize: compact ? 16 : 20 }} />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default IncomingImagePreview;
